export const capacityTiers = {
  header: {
    badge: "Training Programmes",
    title: "Seven Pathways to Industry Transformation",
    subtitle:
      "From factory-floor technicians to strategic innovation leaders — each programme builds the skills, evidence, and confidence needed to drive real change.",
  },

  blackBelt: {
    title: "Innovation Black Belt",
    tagline: "The Apex Certification for Innovation Leaders",
    hoursTraining: "128",
    hoursProblemSolving: "128",
    description:
      "The industry is in the hour of transformation, realizing the need. The Textile Today Innovation Hub is thriving Innovation in the textile and apparel industry to help the sector and its businesses craft the ways to transformation. Innovation Black Belt will create professionals who will go through extensive training and real hands-on problem-solving experience in different particular areas of the Textile & Apparel Industry.",
    teamStructure: {
      title: "Innovation Team Structure",
      members: [
        { role: "Industry Expert", duty: "Guides the participant to accomplish project activities" },
        { role: "Industry Supervisor", duty: "Oversees factory-level execution" },
        { role: "Academic Supervisor", duty: "Provides research and analytical rigor" },
        { role: "Participant", duty: "Drives the project from start to finish" },
      ],
    },
    strategyNote:
      "TTT has set a complete strategy for project accomplishment. The designed strategy holistically guides both the participant and the project in a systematic problem-solving approach.",
    coursesHeading: "Innovation Black Belt Courses",
  },

  factorySkills: {
    title: "Factory Skills Development",
    tagline: "Foundation Course on Factory Skills Development",
    description:
      "The aim of the Factory Skills Development Training program is to train factory professionals as well as students to support the textile and apparel industry in achieving next level of transformation. While Bangladesh is spending a lot of foreign currencies in hiring mid to top level professionals from abroad, the program will build a generation of experts to cater that demand. Academic courses in textile technology and management in Bangladesh are not sufficient to provide skills and knowledge the industry requires immediately. This is where Textile Today works to fulfill the need by combining academic, industrial textile and business experts and by designing dynamic course outlines.",
    certificates: [
      { name: "Certified Apparel Manufacturing Technologist", url: "https://training.textiletoday.com.bd/certified-apparel-manufacturing-technologist/" },
      { name: "Certified Apparel Merchandiser", url: "https://training.textiletoday.com.bd/certified-apparel-merchandiser/" },
      { name: "Certified Fabric Technologist", url: "https://training.textiletoday.com.bd/certified-fabric-technologist/" },
      { name: "Certified Wash Technologist", url: "https://training.textiletoday.com.bd/certified-wash-technologist/" },
      { name: "Certified Dyeing & Printing Technologist", url: "https://training.textiletoday.com.bd/certified-dyeing-printing-technologist/" },
    ],
    coursesHeading: "Factory Skills Development Courses",
  },

  professionalProficiency: {
    title: "Professional Skill Development",
    tagline: "Professional Skill Development of Textile Professionals",
    narrative: [
      "Technical skills are essential for excelling in entry to mid-level positions. However, engineers must also develop people management skills and conceptual skills to advance in their careers. Overall, professional skills are crucial for modern-day engineers, especially those aspiring to reach leadership positions in their jobs or businesses.",
      "While job seekers tirelessly pursue their dream jobs, employers are equally relentless in their search for the perfect candidate. They invest significant effort to uncover exceptional talent, yet many aspiring professionals miss opportunities to refine themselves for these roles.",
      "Textile Today's Professional Proficiency Incubator bridges this gap, offering unmatched support and guidance to help you excel professionally and confidently transition into leadership roles.",
      "Through a strategic mix of skill enhancement and behavioral refinement, we empower you to unlock your full potential and achieve the leadership positions you aspire to.",
    ],
    kpiNote:
      "The training courses will prepare participants to achieve their own, departmental and company KPIs (Key Performance Indicators).",
    coursesHeading: "Professional Skills Development Courses",
  },

  sustainabilityManagement: {
    title: "Sustainability Management",
    tagline: "Building a Professionals' Platform for Sustainable Textile Operations",
    description:
      "The program jointly implemented by Textile Today and ERI is not only a training program. It is rather building and facilitating a professionals' platform. Textile Today will remain as the hub for such professionals to facilitate and cater knowledge needs by creating network. Number of promotion and industry engagement activities will push the necessity of hiring such trained professionals in the textile industries of Bangladesh. Regular seminars and workshops will be organized on the associated topics by involving such professionals to make and facilitate a peer to peer learning culture.",
    programs: [
      { name: "Sustainable Use of Resources", slug: "sms-sustainable-use-of-resources" },
      { name: "Sustainable Chemicals and Environmental Management", slug: "sms-sustainable-chemicals-and-environmental-management" },
      { name: "Safety Management", slug: "sms-safety-management" },
      { name: "Compliance (Social & Materials) Management", slug: "sms-compliance-social-and-materials-management" },
      { name: "Sustainability Management System", slug: "sms-sustainability-management-system" },
    ],
    learnMoreUrl: "https://training.textiletoday.com.bd/sustainability-management-programs/",
  },

  internPro: {
    title: "InternPro",
    tagline: "Exclusive Program for Outgoing Textile Engineering Students",
    description:
      "Textile Today Training launches InternPro, an exclusive program for the outgoing bachelor degree students of textile engineering to best utilize of internship period. The InternPro program will provide opportunities to the student to gain professional skills through a substantive learning experience on relative field. InternPro creates this opportunity through organizational form with proper guideline that will help an Intern to be ready to take the existing challenges of the industry.",
    learnMoreUrl: "/training",
    slug: "intern-internpro-professional-internship-programme",
  },

  ppiWorkshops: {
    title: "PPI Workshops",
    tagline: "Focused Workshops for Immediate Skill Gaps",
    workshops: [
      { name: "Career Planning and Opportunities", slug: "ppi-career-planning-and-opportunities" },
      { name: "Knit Dyeing Production & Troubleshooting", slug: "ppi-knit-dyeing-production-and-troubleshooting" },
      { name: "Commercial & Logistics in Merchandising", slug: "ppi-commercial-and-logistics-in-merchandising" },
      { name: "Towards Zero Defect Quality in Textile & Apparel", slug: "ppi-towards-zero-defect-quality-in-textile-and-apparel" },
      { name: "Factory sourcing & Order Follow Up", slug: "ppi-factory-sourcing-and-order-follow-up" },
    ],
    learnMoreUrl: "https://training.textiletoday.com.bd/ppi-workshop/",
  },

  otherTrainings: {
    title: "Other Trainings",
    tagline: "Specialised Courses for Advanced Practitioners",
    courses: [
      { name: "Managing Dyehouses Towards Zero (Certificate on Dyehouse Management)", slug: "ot-managing-dyehouses-towards-zero" },
      { name: "Testing of Light Fastness & Weathering of Textile", slug: "ot-testing-of-light-fastness-and-weathering-of-textile" },
      { name: "AATCC International Training Program on Evaluating Colorfastness & Physical Properties of Textile", slug: "ot-aatcc-international-training-program-on-evaluating-colorfastness-and-physical-properties" },
      { name: "PPI Training on \"Managing Cotton\"", slug: "ot-managing-cotton" },
      { name: "PPI Training on Cost and Financial Management Aspects for Non-Finance Managers (FINMAN)", slug: "ot-finman-cost-and-financial-management" },
    ],
    learnMoreUrl: "https://training.textiletoday.com.bd/other-trainings/",
  },
};